import { PrismaEnums } from '@airreading/common';

export const allRoles = Object.values(PrismaEnums.Role);
export const RolesLabelMap: Record<PrismaEnums.Role, string> = {
  [PrismaEnums.Role.student]: 'Student',
  [PrismaEnums.Role.parent]: 'Parent',
  [PrismaEnums.Role.coach]: 'Teacher',
  [PrismaEnums.Role.org_admin]: 'District Admin',
  [PrismaEnums.Role.air_admin]: 'Air Admin',
  [PrismaEnums.Role.school_admin]: 'School Admin',
  [PrismaEnums.Role.school_contact]: 'School Contact',
  [PrismaEnums.Role.edge_coach]: 'Edge Tutors',
};
